module.exports = "../static/media/yh.0628d33a.png";